import moment from "moment";
import React from "react";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";
import { Bold14 } from "../components2/common";
import { NormalDesc } from "../components/common";
import "./bankconnect.scss";

const Dable = styled.table`
  font-size: 14px;
  text-align: center;

  a {
    cursor: pointer;
  }
  td {
    font-weight: 400;
  }
  tr:nth-child(odd) {
    background-color: #f8f8f8;
  }
  th:nth-child(1),
  td:nth-child(1) {
    padding-left: 50px;
    @media (max-width: 786px) {
      padding-left: 4%;
    }
  }
`;

const StatusLabel = styled.div`
  display: inline-block;
  /* border-width: 2px; */
  /* border-style: solid; */
  padding: 2px 10px;
  font-weight: 400;
  border-radius: 4px;
  background-color: ${(props) => (props.status ? "#E2F3FD" : "#FFF3E4")};
  color: ${(props) => (props.status ? "#11A1F1" : "#FFA01F")};
`;
export default class HealthTable extends React.Component {
  state = {
    page: 0,
    perpage: 10,
  };

  getBankIcon = (bank) => {
    return `https://finbox-cdn.s3.ap-south-1.amazonaws.com/bank_logos/${bank}.png`;
  };

  render() {
    const rows = this.props.data;
    if (this.props.loading)
      return (
        <div
          style={{
            display: "flex",
            padding: 30,
            justifyContent: "center",
          }}
        >
          Loading...
        </div>
      );
    if (rows.length === 0) {
      return (
        <div className="empty" style={{ marginTop: 30 }}>
          <p className="empty-title h5">No records found</p>
        </div>
      );
    }
    return (
      <>
        <Dable className="table">
          <thead>
            <tr style={{ backgroundColor: "white" }}>
              <th>BANK NAME</th>
              <th>LAST STATUS CHANGE</th>
              <th style={{ textAlign: "center" }}>STATUS</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr>
                <td>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={this.getBankIcon(row.bank.toLowerCase())}
                      width={20}
                      style={{ marginRight: 8 }}
                    />
                    <Bold14>{row.bank}</Bold14>
                  </div>
                </td>
                <td>
                  <NormalDesc>
                    {moment(
                      moment.utc(row.updated_at).local(),
                      "YYYY.MM.DD HH:mm:ss"
                    ).fromNow()}
                  </NormalDesc>
                </td>
                <td style={{ textAlign: "center" }}>
                  <StatusLabel
                    status={row.health_up}
                    data-tip={
                      row.issue_details != null
                        ? "<h1 style='font-size:16px;text-align:left;background: #2C3655;margin:-10px -22px;padding:10px 22px;border-radius:4px 4px 0 0'>Issues</h1></br>" +
                          // "<p style='text-align:left,margin:0'>" +
                          `${row.issue_details}`
                        : // "</p>"
                          ""
                    }
                  >
                    {row.health_up ? "Healthy" : "1 Issue"}
                  </StatusLabel>

                  <ReactTooltip
                    className="healthissue"
                    type="dark"
                    backgroundColor="#1B2542"
                    html="true"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Dable>
      </>
    );
  }
}
